import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import "firebase/database"
import './Products.css';
import { useHistory } from "react-router-dom";
import { Button, Container, Row, Col, Table, Alert, Modal } from 'react-bootstrap'
import { FaTrashAlt } from 'react-icons/fa';
import { SiAddthis } from 'react-icons/si';
import { getAuth } from "firebase/auth";
import { RiEdit2Fill } from 'react-icons/ri';


function Products() {

    const [showDeleteAllModal, setShowDeleteAllModal] = useState(false)
    const [showDeleteItemModal, setShowDeleteItemModal] = useState(false)

    const [productToDelete, setProductToDelete] = useState()
    const [productToDeleteId, setProductToDeleteId] = useState()

    // First modal handler
    const handleShowDeleteAllModal = () => setShowDeleteAllModal(true)
    const handleCloseDeleteAllModal = () => setShowDeleteAllModal(false)


    // Second modal handler
    const handleShowDeleteItemModal = (product) => {
        setShowDeleteItemModal(true)
        setProductToDelete(product.productName)
        setProductToDeleteId(product.id)
    }

    const handleCloseDeleteItemModal = () => setShowDeleteItemModal(false)


    const history = useHistory()
    const [productList, setProductList] = useState()
    const [uid, setUid] = useState()
    const [alert, setAlert] = useState("")

    useEffect(() => {

        const auth = getAuth();
        const user = auth.currentUser;
        setUid(user.uid)

        const newProductRef = firebase.database()
            .ref(uid + "/newProduct")

        newProductRef.on("value", (snapshot) => {
            const products = snapshot.val()
            const productList = []
            for (let id in products) {
                productList.push({ id, ...products[id] })
            }
            setProductList(productList)
        })
    }, [uid])

    useEffect(() => {
        setTimeout(() => {
            setAlert(false);
        }, 2000);
    }, [alert]);

    function addNewProduct() {
        let path = `addProduct`
        history.push(path)
    }

    function deleteProducts() {
        let productsDelRef = firebase.database()
            .ref(uid + "/newProduct")

        if (productsDelRef.remove()) {
            setAlert("All products have been deleted.")
        }
        setShowDeleteAllModal(false)
    }


    function deleteProduct() {
        const newProductRef = firebase.database().ref(uid + "/newProduct/" + productToDeleteId)
        if (newProductRef.remove()) {
            setAlert("Your product is now deleted.")
        }
        setShowDeleteItemModal(false)
    }


    return (
        <div>
            <Container id="products">
                <Row>
                    <Col md={6}><h4>Your products</h4></Col>
                    <Col md={6}>
                        <Button className="products-btn float-end" onClick={addNewProduct} variant="dark"><SiAddthis /></Button>
                        <Button className="products-btn float-end" onClick={handleShowDeleteAllModal} variant="secondary"><FaTrashAlt /></Button>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        {alert && <Alert variant="danger">{alert}</Alert>}
                        <Table striped bordered hover responsive variant="dark">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th className="text-colored">Edit</th>
                                    <th className="text-colored">Product name</th>
                                    <th className="text-colored">Barcode</th>
                                    <th className="text-colored">Custom code</th>
                                </tr>
                            </thead>

                            <tbody>
                                {productList ? productList.map((product, index) => (
                                    <tr key={product.id}>
                                        <td className="center text-colored">{index + 1}</td>
                                        <th><Button onClick={() => history.push({
                                            pathname: `/editProduct`,
                                            state: { productName: product.productName, barcode: product.barcode, code: product.code, id: product.id }
                                        })}
                                            className="edit-buttons"><RiEdit2Fill /></Button>
                                            <Button onClick={() => handleShowDeleteItemModal(product)} className="edit-buttons"><FaTrashAlt /></Button>

                                        </th>
                                        <td className="center">{product.productName}</td>
                                        <td className="center">{product.barcode}</td>
                                        <td className="center">{product.code}</td>
                                    </tr>
                                )) : <tr>{null}</tr>}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container >
            <Container>
                <Button className="btn" onClick={addNewProduct} variant="dark"><SiAddthis className="icon" />Add product</Button>
                <Button onClick={handleShowDeleteAllModal} className="btn float-end" variant="secondary"><FaTrashAlt className="icon" />Delete all products</Button>
            </Container>

            <Modal show={showDeleteAllModal} onHide={handleCloseDeleteAllModal}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body">Are you sure you want to delete all products?</Modal.Body>
                <Modal.Footer>
                    <Button className="delete-btn-modal" variant="secondary" onClick={handleCloseDeleteAllModal}>
                        Close
                    </Button>
                    <Button className="delete-btn-modal" variant="primary" onClick={deleteProducts}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showDeleteItemModal} onHide={handleCloseDeleteItemModal}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body">Are you sure you want to delete this item - {productToDelete}? </Modal.Body>
                <Modal.Footer>
                    <Button className="delete-btn-modal" variant="secondary" onClick={handleCloseDeleteItemModal}>
                        Close
                    </Button>
                    <Button className="delete-btn-modal" variant="primary" onClick={deleteProduct}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

        </div >
    )
}

export default Products